import React from 'react';
import { motion } from 'framer-motion';
interface MiniBarsProps {
  data: number[];
  label?: string;
}
export function MiniBars({
  data,
  label = 'Call activity'
}: MiniBarsProps) {
  const max = Math.max(1, ...data);
  return <div className="flex h-full w-full items-end gap-[2px]" role="img" aria-label={label} data-id="element-114" data-mp="2sk6bdubfde75">
      {data.map((v, i) => <motion.span key={i} className={`block flex-1 rounded-[2px] ${i === data.length - 1 ? 'bg-accent' : 'bg-accent-light/70'}`} initial={false} animate={{
      height: `${Math.max(8, v / max * 100)}%`
    }} transition={{
      duration: 0.25,
      ease: [0.23, 1, 0.32, 1]
    }} data-id="element-115" data-mp="2xflo2ixp541z" data-mpi={i} />)}
    </div>;
}